<template>
  <div>
    <el-row>
      <el-col :span="24">模板名称</el-col>
      <el-col :span="12">
        <el-input
          placeholder="输入模板名称"
          v-model="template_name"
          :disabled="isFixedTemplate"
        ></el-input
      ></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">T&C</el-col>
      <el-col :span="24">
        <el-row
          v-for="(item, index) in templates"
          :key="'template_' + index"
          style="padding-bottom: 5px"
          :gutter="10"
        >
          <el-col :span="1">
            <el-input v-model="templates[index].one_serial" placeholder="序号1">
            </el-input>
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="输入T&C"
              v-model="templates[index].content"
              type="textarea"
              :rows="1"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="templates[index].is_two_serial"
              >子序号</el-checkbox
            >
            &nbsp;
            <el-button @click="Remove(index)">移除</el-button>
            <el-button
              type="primary"
              v-if="index === templates.length - 1"
              @click="Add"
              >添加</el-button
            ></el-col
          >
        </el-row>
      </el-col>
    </el-row>
    <!-- <el-row>
        <el-col :span="24"><div>消息属性</div></el-col>
        <el-col :span="24" v-for="(item, index) in attrs" :key="'attr' + index">
          <el-row :gutter="10">
            <el-col :span="5"
              ><el-input
                v-model="attrs[index].name"
                placeholder="输入属性名(string)"
              ></el-input
            ></el-col>
            <el-col :span="9"
              ><el-input
                v-model="attrs[index].value"
                placeholder="输入值(string)"
              ></el-input
            ></el-col>
            <el-col :span="10"
              ><el-button @click="Remove(index)">移除</el-button>
              <el-button v-if="index === attrs.length - 1" @click="Add"
                >添加</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row> -->
    <el-row>
      <el-button type="primary" @click="save">Save</el-button>
    </el-row>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { request } from '@/network/request';
import { v4 } from 'uuid';

const templates = ref([{ one_serial: '', content: '' }]);
const template_name = ref('');
var id = ref();

onMounted(() => {
  if (window.location.href.indexOf('id') > -1) {
    id.value = window.location.href.split('id=')[1];
    if (id.value) {
      getTemplate();
    }
  }

  if (!id.value) {
    id.value = v4();
  }
});

const getTemplate = () => {
  request({
    url: '/admin/GetTAndCTemplate',
    method: 'get',
    params: {
      id: id.value,
    },
  })
    .then((res) => {
      template_name.value = res.data.template_name;
      templates.value = JSON.parse(res.data.template_text);
    })
    .catch((err) => {
      console.log(err);
    });
};

// Save
const save = async () => {
  var data = {
    id: id.value || '',
    template_name: template_name.value,
    template_text: JSON.stringify(templates.value),
  };

  await request({
    url: '/admin/SaveTAndCTemplate',
    method: 'post',
    data,
  })
    .then((res) => {
      location.href = '/tandcTemplate?type=list';
    })
    .catch((err) => {
      console.log(err);
    });
};

// 添加行
const Add = () => {
  templates.value.push({
    one_serial: '',
    content: '',
  });
};

// 删除行
const Remove = (index) => {
  templates.value.splice(index, 1);
};
</script>
<style scoped></style>
